import controller from './controller';

const template = require('./networkstatus.html');

export default {
    bindings: {
        device: '<',
        onPublishEvent: '&'
    },
    controller,
    template
};
